import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CourtComponent } from './court.component';
import { CreateFormComponent } from '../_shared/create-form/create-form.component';

const routes: Routes = [
  {
    path    : 'court',
    children: [
      {path: '', component: CourtComponent},
      {path: 'create', component: CreateFormComponent, data: {editorType: 'create', componentName: 'court'}},
      {path: ':id/edit', component: CreateFormComponent, data: {editorType: 'edit', componentName: 'court'}},
    ],
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class CourtRoutingModule {
}
